module.exports = __webpack_public_path__ + "img/link-banner-tr.b67ac9d9.png";